/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CorrespondingCredResponse
 */
export interface CorrespondingCredResponse {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof CorrespondingCredResponse
     */
    said?: string;
}

/**
 * Check if a given object implements the CorrespondingCredResponse interface.
 */
export function instanceOfCorrespondingCredResponse(value: object): boolean {
    return true;
}

export function CorrespondingCredResponseFromJSON(json: any): CorrespondingCredResponse {
    return CorrespondingCredResponseFromJSONTyped(json, false);
}

export function CorrespondingCredResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrespondingCredResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
    };
}

export function CorrespondingCredResponseToJSON(value?: CorrespondingCredResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
    };
}

